import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./BarChart.css";
const BarChart4 = ({ categories = [], series = [] }) => {
  const options = {
    chart: {
      type: "column",
    },
    rangeSelector: {
      selected: 2,
    },
    title: {
      text: "Number of Reservations Vs Rate Code",
      align: "left",
    },
    xAxis: {
      categories,
      crosshair: true,
      accessibility: {
        description: "Rate code",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Reservations",
      },
    },
    tooltip: {
      pointFormat:
      "Rate_Code: <b>{point.category}</b><br>" +
        "Reservations: <b> {point.y}</b><br>",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        minPointLength: 3,
      },
    },
    series: [
      {
        name: "Rate code",
        data: series,
      },
    ],
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
export default BarChart4;